import React from 'react';

import AnchorActivityItem from '../AnchorActivityItem/AnchorActivityItem';

const MarkedAnchorItem = (props) => {
  const { action, actionTypeLabel, onClickFile, subject } = props;

  return (
    <React.Fragment>
      <AnchorActivityItem
        actionTypeLabel={`${action}`}
        filename={subject}
        onClickFile={onClickFile}
      />
      <span> {actionTypeLabel} </span>
    </React.Fragment>
  );
};

export default MarkedAnchorItem;
